import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './HerbalSlider.css';

const HerbalSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [offset, setOffset] = useState(0);
  const sliderRef = useRef(null);
  const animationRef = useRef(null);

  const slides = [
    {
      id: 1,
      image: "//am-herbal.org/wp-content/uploads/2024/08/CALENDULA-YELLOW_MATTISON_712072.jpg",
      alt: "CALENDULA-YELLOW_MATTISON_712072",
      key: "rs-58"
    },
    {
      id: 2,
      image: "//am-herbal.org/wp-content/uploads/2024/08/ADP170815_3909.webp",
      alt: "ADP170815_3909",
      key: "rs-59"
    },
    {
      id: 3,
      image: "//am-herbal.org/wp-content/uploads/2024/08/image.jpg",
      alt: "image",
      key: "rs-60"
    },
    {
      id: 4,
      image: "//am-herbal.org/wp-content/uploads/2024/08/MJR080808American_141.jpg",
      alt: "MJR080808American_141",
      key: "rs-61"
    },
    {
      id: 5,
      image: "//am-herbal.org/wp-content/uploads/2024/08/parsf3_zoom.jpg",
      alt: "parsf3_zoom",
      key: "rs-62"
    },
    {
      id: 6,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.20.43_043e56bf.jpg",
      alt: "WhatsApp Image 2024-08-04 at 01.20.43_043e56bf",
      key: "rs-63"
    },
    {
      id: 7,
      image: "//am-herbal.org/wp-content/uploads/2024/08/1722409218196-1.jpg",
      alt: "1722409218196",
      key: "rs-82"
    },
    {
      id: 8,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.20.44_c29b1b42.jpg",
      alt: "WhatsApp Image 2024-08-04 at 01.20.44_c29b1b42",
      key: "rs-64"
    },
    {
      id: 9,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.21.29_25d38c5c.jpg",
      alt: "WhatsApp Image 2024-08-04 at 01.21.29_25d38c5c",
      key: "rs-65"
    },
    {
      id: 10,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.21.29_3982a7b6.jpg",
      alt: "WhatsApp Image 2024-08-04 at 01.21.29_3982a7b6",
      key: "rs-66"
    },
    {
      id: 11,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.51-1.jpeg",
      alt: "WhatsApp-Image-2024-08-04-at-20.05.51 (1)",
      key: "rs-81"
    },
    {
      id: 12,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.52-1-1.jpeg",
      alt: "WhatsApp-Image-2024-08-04-at-20.05.52-1",
      key: "rs-83"
    },
    {
      id: 13,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.53-2.jpeg",
      alt: "WhatsApp-Image-2024-08-04-at-20.05.53",
      key: "rs-84"
    },
    {
      id: 14,
      image: "//am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.53-1-1.jpeg",
      alt: "WhatsApp-Image-2024-08-04-at-20.05.53-1",
      key: "rs-90"
    }
  ];

  // مضاعفة الشرائح لإنشاء حلقة لا متناهية
  const infiniteSlides = [...slides, ...slides, ...slides];
  const totalSlides = slides.length;

  // حساب الفهرس الحقيقي في الشرائح الأصلية
  const getRealIndex = (index) => {
    return ((index % totalSlides) + totalSlides) % totalSlides;
  };

  // حساب خصائص كل شريحة
  const getSlideProperties = (index) => {
    const centerIndex = currentSlide + totalSlides; // المركز في الجزء الأوسط
    const position = index - centerIndex;
    const distance = Math.abs(position);

    let transformX = position * 395;
    let opacity = 1;
    let zIndex = 95;
    let visibility = 'visible';

    // تطبيق تأثيرات التعتيم بناءً على المسافة
    if (position === 0) {
      zIndex = 100;
      opacity = 1;
    } else if (Math.abs(position) === 1) {
      zIndex = 95;
      opacity = 0.8;
    } else if (Math.abs(position) === 2) {
      zIndex = 90;
      opacity = 0.6;
    } else if (Math.abs(position) === 3) {
      zIndex = 85;
      opacity = 0.4;
    } else if (Math.abs(position) === 4) {
      zIndex = 80;
      opacity = 0.3;
    } else if (Math.abs(position) === 5) {
      zIndex = 75;
      opacity = 0.2;
    } else if (Math.abs(position) === 6) {
      zIndex = 70;
      opacity = 0.1;
    } else {
      opacity = 0;
      visibility = 'hidden';
    }

    return {
      transform: `translate3d(${transformX + offset}px, 0px, 0px)`,
      opacity: opacity,
      zIndex: zIndex,
      visibility: visibility
    };
  };

  // الحركة التلقائية
  useEffect(() => {
    const moveSlides = () => {
      setOffset(prev => {
        const newOffset = prev - 2; // سرعة الحركة
        if (Math.abs(newOffset) >= 395) {
          setCurrentSlide(prev => {
            const newSlide = prev + 1;
            // إعادة التعيين عندما نصل للنهاية
            if (newSlide >= totalSlides) {
              return 0;
            }
            return newSlide;
          });
          return 0;
        }
        return newOffset;
      });
    };

    animationRef.current = setInterval(moveSlides, 50); // تحديث كل 50ms

    return () => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
    };
  }, [totalSlides]);

  // إيقاف الحركة التلقائية أثناء السحب
  useEffect(() => {
    if (isDragging && animationRef.current) {
      clearInterval(animationRef.current);
    } else if (!isDragging && !animationRef.current) {
      const moveSlides = () => {
        setOffset(prev => {
          const newOffset = prev - 2;
          if (Math.abs(newOffset) >= 395) {
            setCurrentSlide(prev => {
              const newSlide = prev + 1;
              if (newSlide >= totalSlides) {
                return 0;
              }
              return newSlide;
            });
            return 0;
          }
          return newOffset;
        });
      };
      animationRef.current = setInterval(moveSlides, 50);
    }
  }, [isDragging, totalSlides]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX || e.touches[0].clientX);
    setCurrentX(e.clientX || e.touches[0].clientX);
    
    // إيقاف الحركة التلقائية
    if (animationRef.current) {
      clearInterval(animationRef.current);
      animationRef.current = null;
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const clientX = e.clientX || e.touches[0].clientX;
    const diff = clientX - currentX;
    
    setOffset(prev => prev + diff);
    setCurrentX(clientX);
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    
    const diff = currentX - startX;
    const slideWidth = 395;
    
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        // سحب لليسار - الانتقال للشريحة السابقة
        setCurrentSlide(prev => {
          const newSlide = prev - 1;
          return newSlide < 0 ? totalSlides - 1 : newSlide;
        });
      } else {
        // سحب لليمين - الانتقال للشريحة التالية
        setCurrentSlide(prev => {
          const newSlide = prev + 1;
          return newSlide >= totalSlides ? 0 : newSlide;
        });
      }
    }
    
    setOffset(0);
    setIsDragging(false);
  };

  return (
    <div className="herbal-slider-container">
      <div className="wrap mcb-wrap mcb-wrap-nhxxz48lq one tablet-one mobile-one clearfix">
        <div className="mcb-wrap-inner mcb-wrap-inner-nhxxz48lq">
          <div className="mcb-wrap-background-overlay"></div>
          <div className="column mcb-column mcb-item-9j3nnf6bh one tablet-one mobile-one column_slider_plugin">
            <div className="mcb-column-inner mcb-column-inner-9j3nnf6bh mcb-item-slider_plugin-inner">
              <div className="mfn-main-slider mfn-rev-slider">
                <div 
                  className="revolution-slider-container"
                  style={{
                    background: 'transparent',
                    padding: '1px',
                    margin: '0px auto',
                    height: '298px',
                    display: 'block',
                    width: 'auto',
                    overflow: 'hidden' // تغيير إلى hidden لمنع التمرير
                  }}
                >
                  <div 
                    className="slider-module"
                    style={{
                      height: '296px',
                      width: '1194px',
                      overflow: 'hidden',
                      touchAction: 'pan-y',
                      cursor: isDragging ? 'grabbing' : 'grab',
                      userSelect: 'none',
                      margin: '0 auto',
                      position: 'relative'
                    }}
                  >
                    <div className="carousel-wrapper">
                      <div 
                        ref={sliderRef}
                        className="slides-container"
                        style={{
                          overflow: 'visible',
                          position: 'absolute',
                          visibility: 'visible',
                          maxHeight: 'none',
                          height: '100%',
                          width: '100%',
                          opacity: 1,
                          transformStyle: 'flat',
                          perspective: '1200px',
                          transform: `translate3d(${offset}px, 0px, 0px)`,
                          touchAction: 'pan-y',
                          transition: isDragging ? 'none' : 'transform 0.1s linear'
                        }}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                        onTouchStart={handleMouseDown}
                        onTouchMove={handleMouseMove}
                        onTouchEnd={handleMouseUp}
                      >
                        {infiniteSlides.map((slide, index) => {
                          const properties = getSlideProperties(index);
                          const realIndex = getRealIndex(index - totalSlides + currentSlide);
                          
                          return (
                            <div
                              key={`${slide.key}-${index}`}
                              className="rs-slide"
                              style={{
                                position: 'absolute',
                                borderRadius: '25px',
                                overflow: 'hidden',
                                height: '100%',
                                width: '380px',
                                touchAction: 'pan-y',
                                transformStyle: 'flat',
                                transformOrigin: '50% 50%',
                                left: '50%',
                                marginLeft: '-190px',
                                ...properties
                              }}
                              data-key={slide.key}
                              data-title="Slide"
                              data-isactiveslide={index === currentSlide + totalSlides}
                            >
                              <div className="slide-background">
                                <div className="rs-sbg-wrap">
                                  <div 
                                    className="rs-sbg"
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      touchAction: 'pan-y'
                                    }}
                                  >
                                    <img 
                                      src={slides[realIndex].image} 
                                      alt={slides[realIndex].alt}
                                      className="slide-image"
                                      loading="lazy"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                      }}
                                      onError={(e) => {
                                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgwIiBoZWlnaHQ9IjI5NiIgdmlld0JveD0iMCAwIDM4MCAyOTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzODAiIGhlaWdodD0iMjk2IiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xOTAgMTQ4QzE5MCAxNDggMTcwIDEyOCAxNzAgMTE4QzE3MCAxMDggMTgwIDk4IDE5MCA5OEMyMDAgOTggMjEwIDEwOCAyMTAgMTE4QzIxMCAxMjggMTkwIDE0OCAxOTAgMTQ4WiIgZmlsbD0iI0Q4RDhEOCIvPgo8cGF0aCBkPSJNMjAwIDE1OEMyMDAgMTU4IDE4MCAxNzggMTgwIDE4OEMxODAgMTk4IDE5MCAyMDggMjAwIDIwOEMyMTAgMjA4IDIyMCAxOTggMjIwIDE4OEMyMjAgMTc4IDIwMCAxNTggMjAwIDE1OFoiIGZpbGw9IiNEOEQ4RDgiLz4KPC9zdmc+';
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HerbalSlider;